import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from "@material-ui/core";
import { ADMIN_THEME } from "../util/theme";

interface DialogModalProps {
  contentType?: "text" | "custom";
  title?: string;
  body?: string;
  component?: React.ReactElement;
  open: boolean;
  fullWidth?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  acceptText?: string;
  dismissText?: string;
  onAccepted?: () => void;
  onDismissed: () => void;
}

const useStyles = () =>
  makeStyles((theme: Theme) =>
    createStyles({
      title: {
        color: ADMIN_THEME.titleTextColor,
        backgroundColor: ADMIN_THEME.section.backgroundColor
      },
      content: {
        color: theme.palette.text.primary,
        backgroundColor: ADMIN_THEME.section.backgroundColor
      },
      actions: {
        backgroundColor: ADMIN_THEME.section.backgroundColor
      }
    })
  );

const DialogModal: React.FC<DialogModalProps> = (props) => {
  const styles = useStyles()();

  let maxWidth: "xs" | "sm" | "md" | "lg" | "xl" = "xs",
    fullWidth = false,
    title = "Purity International Consultancy LTD",
    dismissText = "Close",
    contentType = "text";

  if (props.contentType) {
    contentType = props.contentType;
  }

  if (props.title) {
    title = props.title;
  }

  if (props.dismissText) {
    dismissText = props.dismissText;
  }

  if (props.maxWidth) {
    maxWidth = props.maxWidth;
  }

  if (props.fullWidth) {
    fullWidth = props.fullWidth;
  }

  if (!props.open) {
    return null;
  }

  return (
    <Dialog maxWidth={maxWidth} fullWidth={fullWidth} keepMounted open={props.open} onClose={props.onDismissed}>
      <DialogTitle className={styles.title}>{title}</DialogTitle>
      <DialogContent className={styles.content}>
        {contentType === "text" ? (
          <DialogContentText color="inherit" style={{ textAlign: "justify" }}>
            {props.body}
          </DialogContentText>
        ) : props.component ? (
          props.component
        ) : null}
      </DialogContent>
      <DialogActions className={styles.actions}>
        {props.acceptText && props.onAccepted && (
          <Button onClick={props.onAccepted} color="primary">
            {props.acceptText}
          </Button>
        )}
        <Button onClick={props.onDismissed} color="primary">
          {dismissText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(DialogModal);
